module.exports = __webpack_public_path__ + "assets/2e2f8b1bb175f7abed1b9a280ebef95e.png";